import { StylishNewButton } from '../../DesignSystems/New/StylishNewButton';
import React from 'react';
import { useSitrepSectionWizardContext } from './SitrepSectionWizardContext';
import { SITREP_SECTION_STEPS } from './types';

/**
 * This component renders three possible buttons:
 *
 * - Back: Goes to the previous step (if not on the first step)
 * - Next: Goes to the next step (if not on the last step)
 * - Create: Finalizes the section (if on the last step)
 */
const SitrepSectionWizardFooter = ({
  setIsEditingSitrepSections,
}: {
  setIsEditingSitrepSections: (isEditing: boolean) => void;
}) => {
  const {
    activeStep,
    sectionName,
    handleNext,
    handleBack,
    handleCreateSectionTemplate,
  } = useSitrepSectionWizardContext();

  return (
    <div className="sidebar-footer d-flex justify-content-end gap-3 px-3 align-self-end position-fixed">
      {activeStep.id > 1 ? (
        <StylishNewButton
          className="button--secondary color-white"
          onClick={handleBack}
        >
          Back
        </StylishNewButton>
      ) : (
        <StylishNewButton
          className="button--secondary color-white"
          onClick={() => setIsEditingSitrepSections(false)}
        >
          Cancel
        </StylishNewButton>
      )}
      {activeStep.id === SITREP_SECTION_STEPS.length ||
      (activeStep.id === 1 && sectionName && sectionName != '') ? (
        <StylishNewButton
          className="button--primary"
          onClick={handleCreateSectionTemplate}
        >
          Create
        </StylishNewButton>
      ) : (
        <StylishNewButton className="button--primary" onClick={handleNext}>
          Next
        </StylishNewButton>
      )}
    </div>
  );
};

export default SitrepSectionWizardFooter;
